module.exports = __webpack_public_path__ + "img/0.b68569c6.png";